import { render } from "./FlightPolicies.vue?vue&type=template&id=070f3613&scoped=true"
import script from "./FlightPolicies.vue?vue&type=script&lang=js"
export * from "./FlightPolicies.vue?vue&type=script&lang=js"

import "./FlightPolicies.vue?vue&type=style&index=0&id=070f3613&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070f3613"]])

export default __exports__